import { __rest } from '../../_virtual/_tslib.js';
import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../node_modules/@flixbus/honeycomb/dist/scss/components/box.scss.js';
import HoneyBem from '../../packages/honey-bem/honey-bem.js';
import '@flixbus/honeycomb-icons-react';
import { InnerRefPropType } from '../../packages/props-utils/prop-types.js';
import { BOX_APPEARANCES } from './types.js';
import { Injecss } from '../../packages/injecss/injecss.js';

const bem = new HoneyBem('box', styles);
function Box(_a) {
  var {
      children,
      highlighted = false,
      extraClasses = '',
      innerRef,
      small = false,
      appearance = undefined
    } = _a,
    rest = __rest(_a, ["children", "highlighted", "extraClasses", "innerRef", "small", "appearance"]);
  const boxClassNames = bem.b([appearance, {
    highlighted,
    small
  }], extraClasses);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    ref: innerRef,
    className: boxClassNames
  }, rest), children);
}
Box.displayName = 'Box';
Box.propTypes = {
  children: PropTypes.node.isRequired,
  highlighted: PropTypes.bool,
  innerRef: InnerRefPropType,
  small: PropTypes.bool,
  extraClasses: PropTypes.string,
  appearance: PropTypes.oneOf(BOX_APPEARANCES)
};
var box = Injecss(Box, styles);

export { Box, box as default };
